export const blogData = [
  {
    id: 1,
    title: "Kotlin Multiplatform Mobile! Part 4",
    description: "LocalDb in KMM (SQLDelight) Part-4",
    date: "Sep 17, 2020",
    image:
      "https://pbs.twimg.com/media/EiNm40dWsAIO5E9?format=png&name=900x900",
    url: "https://medium.com/mounty-engineering/localdb-in-kmm-sqldelight-part-4-573ea0904156",
  },
  {
    id: 2,
    title: "Kotlin Multiplatform Mobile! Part 3",
    description: "Networking in KMM (KTOR) Part-3",
    date: "Aug 14, 2020",
    image: "https://miro.medium.com/max/840/1*qCB8V1HcQq7u7mJ98Xvo-w.png",
    url: "https://medium.com/mounty-engineering/networking-in-kmm-ktor-part-3-78ec68787f6a",
  },
  {
    id: 3,
    title: "Kotlin Multiplatform Mobile! Part 2",
    description:
      "Move android code to KMM Shared Module| How we migrated our code to Kotlin Multiplatform Mobile! Part 2",
    date: "jul 1, 2020",
    image:
      "https://blog.jetbrains.com/wp-content/uploads/2020/08/KMM_release_banners_blogpost.png",
    url: "https://medium.com/mounty-engineering/move-android-code-to-kmm-shared-module-how-we-migrated-our-code-to-kotlin-multiplatform-mobile-e86d70e17a81",
  },
  {
    id: 4,
    title: "Kotlin Multiplatform Mobile! Part 1",
    description:
      "IS KMM production-ready? How we migrated our code to Kotlin Multiplatform Mobile! Part 1",
    date: "jun 12, 2020",
    image: "https://miro.medium.com/max/840/1*qCB8V1HcQq7u7mJ98Xvo-w.png",
    url: "https://medium.com/mounty-engineering/is-kmm-production-ready-how-we-migrated-our-code-to-kotlin-multiplatform-mobile-part-1-d7329874a402",
  },

  // {
  //     id: 5,
  //     title: 'GET MICHAEL\'S OR TREVOR\'S VEHICLES FULLY UPGRADED IN GTA V FOR FREE',
  //     description: 'In case you haven\'t heard of this game, GTA stands for \'Grand Theft Auto\'. It is an open-world game published by Rockstar Games.',
  //     date: 'Oct 1, 2020',
  //     image: 'https://1.bp.blogspot.com/-jhdtUBIRD_s/XxLFKQuRz9I/AAAAAAAABsM/mClfbfDFKvsUwA7Wyi25Lzu3DEmL2lxrACNcBGAsYHQ/s1919/gta.jpg',
  //     url: 'https://hackzism.blogspot.com/2020/07/how-can-you-get-michaels-or-trevors.html'
  // },
];

// Do not remove any fields.
// Leave it blank instead as shown below.

/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/
